import { Theme01 } from "pages";
import { Theme01Static } from "components";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.Theme01.path,
      name: "Theme01",
      key: routesMap.Theme01.path,
      commonRoute: false,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme01Static />,
    },
    {
      path: `${routesMap.Theme01.path}/:id`,
      name: "Theme01",
      key: `${routesMap.Theme01.path}/:id`,
      commonRoute: true,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme01 />,
    },
  ];
}
